import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDebug from './debug.reducer';

export const selectDebugState = createFeatureSelector<fromDebug.DebugState>(
  fromDebug.debugFeatureKey,
);

export const isDebugMode = createSelector(
  selectDebugState,
  (state) => state.enabled,
);
